import React from 'react';
import { useResult, useResultUpdate } from "../../components/context/ResultContext";
import { useData } from "../../components/context/DataContext";
import { renderFormattedText } from "../../utils/helpers";
import pdfIcon from "../../assets/images/smlPDFicon.svg";
import pdffile from "../../assets/documents/sandoz_drag_and_drop_interactive_triangle.pdf";
import { gaPDFDownload, gaButtonClick } from '../../utils/gatags';
import './Results.css'

const Results = (props) => {

    const json = useData();
    const userResult = useResult();
    const summaryBtnClick = (res) => {
        if (res === "download") {
            gaPDFDownload(pdffile, pdffile);
            window.open(pdffile, '_blank');
        } 
        if (res === "restart") {
            props.clickhandle();
            gaButtonClick("button", "button_click", "restart_quiz" );
        }
    }

    const summaryString = () => {
        const result2txt = json.results[1].result2a + userResult.result + json.results[1].result2b + (3 - userResult.attempts) + json.results[1].result2c
        return result2txt;
    }

    return (
        <>
            <div id="results" className="results">
                {/* {userResult.resultid} - {userResult.attempts} - {userResult.result} */}
                { userResult.resultid === 1 ? (
                    <div id="feedback1" className="results">
                        <div className="results-txt">
                            {json && renderFormattedText(json.results[0].result1)}
                        </div>
                        <div className="results-btn-wrap">
                            <div onClick={() => summaryBtnClick("download")} id="res1" className="results-btn"><img src={pdfIcon} alt="PDF icon" />{json && renderFormattedText(json.results[0].btnlbl)}</div>
                        </div>
                    </div>
                    ) : ""
                }
                { userResult.resultid === 2 ? (
                    <div id="feedback2" className="results">
                        <div className="results-txt">
                        {json && renderFormattedText(summaryString())}
                        </div>
                        <div className="results-btn-wrap">
                            <div onClick={() => summaryBtnClick("restart")} id="res2" className="results-btn">{json && renderFormattedText(json.results[1].btnlbl)}</div>
                        </div>
                    </div>
                    ) : ""
                }
                { userResult.resultid === 3 ? (
                    <div id="feedback3" className="results">
                        <div className="results-txt">
                            {json && renderFormattedText(json.results[2].result3)}
                        </div>
                        <div className="results-btn-wrap">
                            <div onClick={() => summaryBtnClick("download")} id="res3" className="results-btn"><img src={pdfIcon} alt="PDF icon" />{json && renderFormattedText(json.results[2].btnlbl)}</div>
                        </div>
                    </div>
                    ) : ""
                }
            </div>
        </>
    );
};

export default Results;